export abstract class JsonDeserializable {
  static fromJsonObject(json: any): JsonDeserializable {
    throw new Error('Método no implementado.');
  }
}